const config = require('./config.yaml');

if ($('.js-left-nav').data('template') === 'vertical-accordeon') {
	if ($.fn.velocity) {
		$('.js-icon-left-nav').on('click touchstart', function (event) {
			var $thisLink = $(this).parent('.js-left-link');

			if ($thisLink.hasClass('is-expand') && config.closable) {
				event.preventDefault();
				closeLeftMenu($thisLink);
			} else if (config.expandable) {
				event.preventDefault();
				openLeftMenu($thisLink, event);
			}
		});

		function closeLeftMenu(element) {
			const $this = element;

			$this.closest('li').find('ul.is-expand')
				.velocity('slideUp', {
					duration: 200,
					complete: function () {
						$(this).removeClass('is-expand');
					}
				});

			$this.removeClass('is-expand');
		}

		function openLeftMenu(element, event) {
			const $this = element;
			const $thisList = $this.parent('.nav__link-wrapper').siblings('.nav__list');

			if ($thisList.length && !$thisList.hasClass('is-expand')) {
				event.preventDefault();

				if (config.hidePreviousListOnExpand) {
					const $otherItems = $this.closest('.nav__item--left').siblings('.nav__item--left');

					$otherItems.find('ul.is-expand')
						.velocity('slideUp', {
							duration: 200,
							complete: function () {
								$(this).removeClass('is-expand');
							}
						});
					$otherItems.find('a.is-expand').removeClass('is-expand');
				}

				$thisList
					.velocity('slideDown', {
						duration: 400,
						delay: 200,
						complete: function () {
							$(this).addClass('is-expand');
						}
					});
				$this.addClass('is-expand');
			}
		}

		$(document).on('click', function (event) {
			if (!$(event.target).closest('.js-left-nav').length && config.autoClose) {
				closeLeftMenu($('.js-left-nav .is-expand'));
			}
		});
	} else {
		console.error('Menu: Для работы меню необходимо подключить VelocityJS и VelocityJS UI Pack');
	}
}



// WEBPACK FOOTER //
// ./temp/components/menu/vertical-accordeon/index.js